import type { FinancialSyncStatusResponse } from "@features/api/FinancialSyncStatusApi";

const asRecord = (value: unknown): Record<string, unknown> | null =>
  typeof value === "object" && value !== null
    ? (value as Record<string, unknown>)
    : null;

export function parseFinancialSyncStatus(
  response: unknown,
): FinancialSyncStatusResponse | null {
  const outer = asRecord(response);
  // HttpClient adds response.data around the server's { code, msg, data } body.
  const body =
    outer && "code" in outer ? outer : asRecord(outer?.data ?? response);
  if (body && "code" in body && body.code !== 0) {
    throw new Error("sync-status API returned an error");
  }
  const status = asRecord(body?.data ?? body);
  if (!status || typeof status.summary !== "string") {
    return null;
  }
  return {
    ...status,
    accounts: Array.isArray(status.accounts) ? status.accounts : [],
  } as unknown as FinancialSyncStatusResponse;
}
